export default {
  data: {
    'docu-file-id-123': {
      signedUrl:
        'https://assets.eclipx.xyz/novatedleasing/documents/FPlus-novated-service-agreement.pdf'
    }
  }
};
